import { render, staticRenderFns } from "./UpdateInventory.vue?vue&type=template&id=57e75148&scoped=true&"
import script from "./UpdateInventory.vue?vue&type=script&lang=js&"
export * from "./UpdateInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e75148",
  null
  
)

export default component.exports